import * as React from 'react';
import UserLookup from '../../common/form-controls/UserLookup';
import FieldHandler from '../../../models/interfaces/FieldHandler';

interface CustodianTwoInputProps extends FieldHandler<string> { }

interface CustodianTwoInputState { }

export class CustodianTwoInput extends React.Component<CustodianTwoInputProps, CustodianTwoInputState> {
	render() {
		return (
			<UserLookup
				id="custodian-two-lookup"	
				label="Custodian Two"
				note={!this.props.hideNotes && 'Custodians are responsible for executing the above actions on behalf of the subscription owner'}
				{...this.props}
			/>
		);
	}
}